import { fromJS } from 'immutable'

import { setToken, setError } from './actions.js'

let defaultState = fromJS({
  userToken: null,
  error: null
})

export default function auth(state = defaultState, action) {
  state = fromJS(state) // Force immutable in case of rehydration
  switch (action.type) {
    case setToken.type:
      return state
        .set('userToken', action.payload ? fromJS(action.payload) : null)
        .set('error', null)
    case setError.type:
      return state.set('userToken', null).set('error', action.payload)
    default:
      return state
  }
}

export const selectToken = state => state.auth.get('userToken')
export const selectError = state => state.auth.get('error')
